import { useEffect, useRef } from "react";

const useClickOutside = (handler: any) => {
  const domNodeRef: any = useRef();

  useEffect(() => {
    const maybeHandler = (event: any) => {
      if (!domNodeRef.current?.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener("mousedown", maybeHandler);
    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  }, [handler]);

  return domNodeRef;
};

export default useClickOutside;
